import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "s20" }
const _hoisted_3 = { class: "widget shadow-100 pb-2" }
const _hoisted_4 = { class: "container-full-2 my-5" }
const _hoisted_5 = { class: "s7" }
const _hoisted_6 = { class: "font-semibold mt-4" }
const _hoisted_7 = { class: "text-sm text-grey-500" }
const _hoisted_8 = { class: "table separator skin1 selection" }
const _hoisted_9 = {
  class: "btn-circle",
  for: "check_all"
}
const _hoisted_10 = ["checked"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "selection-item" }
const _hoisted_13 = ["for"]
const _hoisted_14 = ["id", "value"]
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }

import { computed, onMounted, ref } from 'vue';
    import axios from 'axios';
import { formatDate } from '@/utils';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketProduitsStocksListView',
  setup(__props) {

    const errorMessage = ref('');
    const loading = ref(false);
    const itemsList = ref([] as any[]);
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return itemsList.value.length == selectedItems.value.length;
    });

    onMounted(() => {
        doListItems();
    });

    async function doListItems() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const httpResponse = await axios.get(`/backoffice/market-produits-stocks/list`);
            itemsList.value = httpResponse.data;
        } catch(error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = itemsList.value.map(i => i.id);
        } else {
            selectedItems.value = [];
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, [
                _cache[1] || (_cache[1] = _createTextVNode("Stocks Market ", -1)),
                _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(itemsList.value.length) + ")", 1)
              ])
            ]),
            _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"s13 flex justify-content-right\"><div class=\"form-field-floating default sm s4_mobile ml-3\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\">Trier</option><option value=\"\" selected>Ordre Décroissant</option><option value=\"\">Ordre Croissant</option><option value=\"\">De A - Z</option><option value=\"\">De Z - A</option></select></div><button class=\"btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter\"><img src=\"/icons/icon-filter.svg\" class=\"btn-icon\" alt=\"\"><span>Options</span></button></div><div class=\"clear-both\"></div><div class=\"filter-set-area\"><div class=\"grid-filter6 mt-4 mb-0\"><div class=\"form-field-floating reactive sm\"><input type=\"date\" class=\"form-input\" name=\"date1\" id=\"date1\" placeholder=\"\"><label for=\"date1\">Date de création &lt;=</label></div><div class=\"form-field-floating reactive sm\"><input type=\"date\" class=\"form-input\" name=\"date2\" id=\"date2\" placeholder=\"\"><label for=\"date2\">Date de création &gt;=</label></div><div class=\"form-field-floating sm\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tout les etats</option><option value=\"\">Actif</option><option value=\"\">Inactif</option></select><label for=\"pays\">Etat <b class=\"color-danger\">*</b></label></div><div class=\"form-field-floating sm\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tout les etats</option><option value=\"\">Actif</option><option value=\"\">Inactif</option></select><label for=\"pays\">Etat <b class=\"color-danger\">*</b></label></div><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-excel.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter Excel</span></button><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-pdf.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter PDF</span></button></div></div>", 3))
          ]),
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("label", _hoisted_9, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "check_all",
                      checked: areAllItemsSelected.value,
                      onChange: handleCheckAll
                    }, null, 40, _hoisted_10)
                  ])
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-down.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Date")
                ], -1)),
                _cache[4] || (_cache[4] = _createElementVNode("th", null, "Produit", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("th", null, "Mouvement", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("th", null, "Stock avant mouvement", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("th", null, "Quantité mouvement", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("th", null, "Stock après mouvement", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("th", null, "Administrateur", -1)),
                _cache[10] || (_cache[10] = _createElementVNode("th", null, [
                  _createElementVNode("button", { class: "btn-ultra white2 tips display-none" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-destroy.svg",
                        class: "btn-icon icon-neutral",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Détruire")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ]),
                  _createElementVNode("button", { class: "btn-ultra white2 tips display-none" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-delete.svg",
                        class: "btn-icon",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Supprimer")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ]),
                  _createElementVNode("button", { class: "btn-ultra white2 tips display-none" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-restaurer.svg",
                        class: "btn-icon icon-neutral",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Restaurer")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ]),
                  _createElementVNode("button", { class: "btn-ultra color2 tips display-none" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-actif.svg",
                        class: "btn-icon",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Actif")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ])
                ], -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (itemsList.value.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("td", { colspan: "9" }, [
                      _createElementVNode("div", { class: "text-center text-grey-700" }, "Aucun élément trouvé")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: 'item_' + index,
                  class: "text-grey-700 over-effect over-effect-scale"
                }, [
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("label", {
                      class: "btn-circle",
                      for: 'item_check_' + index
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: "selectedItems[]",
                        id: 'item_check_' + index,
                        value: item.id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItems).value = $event))
                      }, null, 8, _hoisted_14), [
                        [_vModelCheckbox, selectedItems.value]
                      ])
                    ], 8, _hoisted_13)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", null, _toDisplayString(_unref(formatDate)(item.created_at)), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", null, _toDisplayString(item.produit ? item.produit.designation : item.ref_produit), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", null, _toDisplayString(item.libelle_mouvement), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", _hoisted_15, _toDisplayString(item.stock_before_mouvement), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", _hoisted_16, _toDisplayString(item.quantite_mouvement), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", _hoisted_17, _toDisplayString(item.stock_after_mouvement), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", null, _toDisplayString((item.administrateur.nom != 'null' ? item.administrateur.nom : '') + ' ' + (item.administrateur.prenom != 'null' ? item.administrateur.prenom : '') + ' (' + item.administrateur.username + ')'), 1)
                  ]),
                  _cache[12] || (_cache[12] = _createElementVNode("td", { class: "flex-right mt-1" }, null, -1))
                ]))
              }), 128))
            ])
          ])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
      ])
    ]),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
  ]))
}
}

})